"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            animation: ", " 1s ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    from {\n        opacity: 0.75;\n        transform: scale(0);\n    }\n    to {\n        opacity: 0;\n        transform: scale(3);\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ripple = (0, _styledComponents.keyframes)(_templateObject());

function _default(theme, props) {
  var palette = theme.palette;

  if (props.error) {// theme.labelColor = theme.errorLabelColor;
  }

  if (props.inline) {
    theme.display = 'inline-block';
  }

  var bullet = {
    borderRadius: '50%',
    width: palette.gutter * 1.5 + 'px',
    height: palette.gutter * 1.5 + 'px',
    display: 'inline-block',
    margin: "0 ".concat(palette.gutter, "px"),
    borderWidth: '1px',
    borderStyle: 'solid',
    transitionTimingProperty: palette.transitionFunction,
    transitionDuration: palette.transitionDuration,
    transitionProperty: 'background, border'
  },
      height = (0, _pixelToNumber["default"])(theme.lineHeight) + palette.gutter * 2,
      iconTop = ((0, _pixelToNumber["default"])(theme.lineHeight) - palette.gutter * 3) / 2;
  return {
    root: {
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(palette.fontFamily, "\""),
      width: '300px',
      display: theme.display
    },
    dial: {
      zoom: 1,
      position: 'relative',
      '&:after': {
        clear: 'both',
        content: '""',
        display: 'block',
        height: 0
      }
    },
    label: {
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      color: theme.labelColor,
      width: '100%',
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      display: 'block',
      textAlign: 'center'
    },
    digit: {
      display: 'block',
      "float": 'left',
      margin: 0,
      border: '0 none',
      color: theme.color,
      boxSizing: 'border-box',
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      padding: "".concat(palette.gutter, "px 0"),
      width: '100px',
      background: theme.background,
      cursor: 'pointer',
      transition: "color ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      position: 'relative',
      marginBottom: palette.gutter * 2 + 'px',
      height: height + 'px',
      '&>*': {// display: 'inline-block',
        // verticalAlign: 'middle',
      },
      '&:focus': {
        outline: '0 none',
        color: theme.focusColor,
        backgroundColor: theme.focusBackground
      },
      '&:hover': {
        color: theme.hoverColor,
        backgroundColor: theme.hoverBackground
      },
      '&:active': {
        outline: '0 none',
        color: theme.activeColor,
        backgroundColor: theme.activeBackground
      }
    },
    bullet: _objectSpread({}, bullet, {
      background: theme.bulletIdleBackground,
      borderColor: theme.bulletIdleBorderColor
    }),
    bulletFilled: _objectSpread({}, bullet, {
      background: theme.bulletFilledBackground,
      borderColor: theme.bulletFilledBorderColor
    }),
    bulletWrapper: {
      textAlign: 'center',
      padding: "".concat(palette.gutter * 2, "px 0")
    },
    clear: {
      cursor: 'pointer',
      display: 'inline-block',
      width: palette.gutter * 3,
      height: palette.gutter * 3,
      backgroundImage: "url(\"".concat(theme.clearIcon, "\")"),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      position: 'relative',
      top: iconTop + 'px',
      opacity: 0.38,
      transition: "opacity ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      '&:hover': {
        opacity: 0.87
      }
    },
    deleteDigit: {
      cursor: 'pointer',
      display: 'inline-block',
      width: palette.gutter * 3,
      height: palette.gutter * 3,
      backgroundImage: "url(\"".concat(theme.deleteIcon, "\")"),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      position: 'relative',
      top: iconTop + 'px',
      opacity: 0.38,
      transition: "opacity ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      '&:hover': {
        opacity: 0.87
      }
    },
    input: {
      position: 'absolute',
      zIndex: -1,
      visibility: 'hidden',
      top: 0,
      left: 0
    },
    animationRules: {
      position: 'absolute',
      width: '27px',
      height: '27px',
      top: 0,
      left: '30px',
      backgroundColor: theme.animationBackgroundColor,
      borderRadius: '50%',
      transition: "opacity 2s ".concat(palette.transitionFunction, ", transform 1s ").concat(palette.transitionFunction),
      transitionOrigin: 'center'
    },
    animationFunction: (0, _styledComponents.css)(_templateObject2(), ripple, palette.transitionFunction),
    animationContainer: {
      display: theme.animationDisplay,
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0
    }
  };
}